
module.exports = { 
menu : { 
    home: "首页" ,
    product: "产品",
    scheme: "方案",
    hardware: "硬件",
    case: "案例",
    us: '我们',
    help: '帮助',
    consult: '资讯',
    wisdom: '智见未来'
  }, 
  content:{ 
    main:"这里是内容" 
  } 
}
 


// WEBPACK FOOTER //
// ./src/assets/lang/zh.js